var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"pt-4 px-4"},[_vm._v(" "+_vm._s(_vm.content)+" ")]),(_vm.focus)?_c('p',{staticClass:"date"},[_vm._v(_vm._s(_vm.focus))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }